import { useEffect, useState } from "react";
//Components
import PricingContent from "./PricingContent/PricingContent";
import Loader from "../../components/Loader/Loader";
//Styles
import styles from "./Pricing.module.scss";
import { getPricingPackage } from "../../api/fieldRoutes";
//Amplitude
import * as amplitude from "@amplitude/analytics-browser";
import { toast } from "react-toastify";
import ContactUsToast from "../../components/Toast/ContactUsToast/ContactUsToast";

const Pricing = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [serviceType, setServiceType] = useState({});

  const discountPrice = parseInt(serviceType?.minimumInitialCharge) ?? 0;
  const regularPrice = parseInt(serviceType?.defaultInitialCharge) ?? 0;
  const subscriptionPrice = parseInt(serviceType?.minimumRecurringCharge) ?? 0;

  const discount = (discountPrice / regularPrice) * 100;

  useEffect(() => {
    const fetchPackage = async () => {
      try {
        setIsLoading(true);
        const response = await getPricingPackage();
        setServiceType(response?.data?.serviceTypes[0]);
        setIsLoading(false);
      } catch (err) {
        const errorEvent = {
          event_type: "Error",
          display_name: "Error",
          event_properties: {
            page_name: "eComm - Pricing",
            error_name: "Failed to load price from FieldRoutes",
          },
        };

        amplitude.track(errorEvent);

        toast(<ContactUsToast />, { theme: "dark" });
      }
    };

    fetchPackage();
  }, []);

  useEffect(() => {
    const pageViewedEvent = {
      event_type: "Page Viewed",
      display_name: "Page Viewed",
      event_properties: {
        page_name: "eComm - Pricing",
      },
    };

    const pricingViewedEvent = {
      event_type: "Pricing Viewed",
      display_name: "Pricing Viewed",
      event_properties: {
        page_name: "eComm - Pricing",
      },
    };

    amplitude.track(pricingViewedEvent);
    amplitude.track(pageViewedEvent);
  }, []);

  return (
    <>
      {isLoading ? (
        <div className={styles.pricingLoaderContainer}>
          <Loader />
        </div>
      ) : (
        <PricingContent
          data={{
            name: serviceType?.description ?? "",
            discount,
            regularPrice,
            discountPrice,
            subscriptionPrice,
          }}
        />
      )}
    </>
  );
};

export default Pricing;
